import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ProjectsService } from 'src/app/services/projects.service';
import { SharedArtsDiagramUploadComponent } from '../shared-arts-diagram-upload/shared-arts-diagram-upload.component';
import { ProjectDiagramationVobosComponent } from '../project-diagramation-vobos/project-diagramation-vobos.component';
import { ProjectDiagramationArchivosImgComponent } from '../project-diagramation-archivos-img/project-diagramation-archivos-img.component';
import Swal from 'sweetalert2';
import { MainService } from 'src/app/services/main.service';

// Compatibilidad de PDF.js 6 con navegadores que todavía no incluyen Promise.withResolvers
if (!(Promise as any).withResolvers) {
  (Promise as any).withResolvers = () => {
    let resolver: any;
    let rechazar: any;
    const promise = new Promise((resolve, reject) => {
      resolver = resolve;
      rechazar = reject;
    });
    return { promise, resolve: resolver, reject: rechazar };
  };
}

const pdfjsLib: any = require('pdfjs-dist/build/pdf.js');

@Component({ selector: 'app-shared-arts-diagram-view', 
  templateUrl: './shared-arts-diagram-view.component.html', 
  styleUrls: ['./shared-arts-diagram-view.component.scss'] })
export class SharedArtsDiagramViewComponent implements OnInit, OnDestroy {
  // Referencias de la tabla principal de medios y elementos POP
  @ViewChild(MatPaginator) set paginadorTabla(paginador: MatPaginator | undefined) {
    if (paginador) this.dataSource.paginator = paginador;
  }

  @ViewChild(MatSort) set ordenadorTabla(ordenador: MatSort | undefined) {
    if (ordenador) this.dataSource.sort = ordenador;
  }


  @ViewChild('visorAnotacion') visorAnotacion?: ElementRef<HTMLDivElement>;
  @ViewChild('lienzoPdf') lienzoPdf?: ElementRef<HTMLCanvasElement>;

  // Tabla principal
  dataSource = new MatTableDataSource<any>([]);
  displayedColumns = ['medio', 'pop', 'positions', 'road'];
  loading = true;
  loadError = false;
  mostrarNoDiagramados = false;
  textoBusqueda = '';

  // Vista de posiciones
  filaSeleccionada: any = null;
  detallePosiciones: any[] = [];
  columnasPromociones: string[] = [];
  cargandoDetalle = false;

  // Historial de artes
  arteSeleccionado: any = null;
  archivosArte: any[] = [];
  archivosCompartidosCampana: any[] = [];
  cargandoArtes = false;
  errorArtes = false;
  cambiosArtesPendientes = false;
  huboCambiosGuardados = false;

  // Editor de anotaciones
  archivoAnotando: any = null;
  fuenteImagen: string | SafeUrl = '';
  cargandoImagen = false;
  errorImagen = false;
  esPdfActual = false;
  esImagenesMultiplesActual = false;
  paginaActual = 1;
  totalPaginas = 0;
  anotaciones: any[] = [];
  anotacionesPaginaActual: any[] = [];
  anotacionTemporal: any = null;
  posicionPendiente: any = null;
  posicionesParaAsignar: any[] = [];
  private posicionesAnotables: any[] = [];
  promocionesCampaniaAnotacion: any[] = [];
  columnasPromocionesAnotacion: string[] = [];
  cargandoPromocionesAnotacion = false;

  seleccionando = false;
  puntoInicial: any = null;

  anchoNatural = 0;
  altoNatural = 0;
  anchoBase = 0;
  altoBase = 0;
  nivelZoom = 1;

  guardandoAnotaciones = false;

  private urlTemporalImagen = '';
  private documentoPdf: any = null;
  private renderizadoPdf: any = null;
  private coloresAnotacion = ['#3568ed', '#e45543', '#7a45c6', '#159a8c', '#e39a19', '#3f7f55', '#c44785', '#5d6b86'];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private projectService: ProjectsService,
    private matDialog: MatDialog,
    private sanitizer: DomSanitizer,
    private mainService: MainService,
  ) {
    this.dataSource.filterPredicate = (fila: any, filtro: string) => {
      const opciones = JSON.parse(filtro);
      const contenido = `${fila.medio} ${fila.pop}`.toLocaleLowerCase();
      const coincideBusqueda = contenido.includes(opciones.texto);
      const coincideDiagramacion = opciones.mostrarNoDiagramados || fila.diagrammedPositions.length > 0;
      return coincideBusqueda && coincideDiagramacion;
    };
  }
  async ngOnInit(): Promise<void> {
    if (this.data?.vistaDirecta) {
      await this.abrirHistorialDirecto();
      return;
    }
    await this.loadCombinations();
  }
  ngOnDestroy(): void {
    this.liberarImagen();
    this.liberarPdf();
  }
  buscar(evento: Event): void {
    this.textoBusqueda = (evento.target as HTMLInputElement).value.trim().toLocaleLowerCase();
    this.actualizarFiltro();
  }
  cambiarVisibilidadNoDiagramados(mostrar: boolean): void {
    this.mostrarNoDiagramados = mostrar;
    this.actualizarFiltro();
  }
  private actualizarFiltro(): void {
    this.dataSource.filter = JSON.stringify({
      texto: this.textoBusqueda,
      mostrarNoDiagramados: this.mostrarNoDiagramados
    });
    this.dataSource.paginator?.firstPage();
  }
  trackPosition(_i: number, value: number): number { return value; }
  posicionesDisponibles(total: number): number[] { return Array.from({ length: total }, (_value, index) => index + 1); }
  trackPhase(_i: number, value: any): number { return value.id; }
  identificarIndicador(_i: number, value: any): string { return value.id; }
  accionIndicador(fila: any, fase: any, indicador: any): void {
    if (indicador.type === 'art') {
      this.verArtes(fila, fase);
      return;
    }
    if (!this.esVoboProveedor(indicador.vobo)) {
      this.abrirVobosCompartidos(fila, fase, indicador.vobo);
    }
  }
  estadoPosicion(row: any, position: number): string {
    if (row.annotatedPositions.includes(position)) return 'annotated';
    return row.diagrammedPositions.includes(position) ? 'diagrammed' : 'free';
  }

  estadoPosicionProyecto(proyecto: any, posicion: number): string {
    const anotada = proyecto.posicionesAnotadas.includes(posicion);
    const diagramada = proyecto.posicionesDiagramadas.includes(posicion);
    if (anotada && !diagramada) return 'annotated-without-diagram';
    if (anotada) return 'annotated';
    return diagramada ? 'diagrammed' : 'free';
  }

  async verArtes(fila: any, fase: any): Promise<void> {
    this.arteSeleccionado = { fila, fase };
    this.archivosArte = [];
    this.cargandoArtes = true;
    this.errorArtes = false;

    const consulta = {
      id_proyecto_campana: this.obtenerIdCampana(),
      id_phase: Number(fase.id),
      id_medio: Number(fila.idMedio),
      id_pop: Number(fila.idPop)
    };

    try {
      const respuesta: any = await this.projectService.getDiagramaArchivoSharedImages(consulta).toPromise();
      const datos = respuesta?.data?.archivos || respuesta?.data || respuesta || [];
      const imagenesHijas = respuesta?.dataF || respuesta?.data?.dataF || [];
      const archivos = (Array.isArray(datos) ? datos : [])
        .filter((archivo: any) => Number(archivo.deleted || 0) !== 1)
        .sort((a: any, b: any) => {
          const diferenciaFecha = new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
          return diferenciaFecha || Number(b.id) - Number(a.id);
        });

      const totalArchivos = archivos.length;
      this.archivosArte = archivos.map((archivo: any, indice: number) => ({
        ...archivo,
        imagenes: (Array.isArray(imagenesHijas) ? imagenesHijas : []).filter((imagen: any) =>
          Number(imagen.id_diagrama_archivos_compartidos) === Number(archivo.id)
        ).sort((a: any, b: any) => Number(a.id) - Number(b.id)),
        version: totalArchivos - indice,
        vigente: indice === 0,
        posicionesAnotadas: this.contarPosicionesAnotadas(archivo.selected_config, fila, fase)
      }));
    } catch {
      this.errorArtes = true;
    } finally {
      this.cargandoArtes = false;
    }
  }

  volverDesdeArtes(): void {
    const debeRecargar = this.cambiosArtesPendientes;
    this.cerrarAnotacion();
    this.arteSeleccionado = null;
    this.archivosArte = [];
    this.errorArtes = false;
    if (debeRecargar) {
      this.cambiosArtesPendientes = false;
      this.loading = true;
      this.loadError = false;
      this.loadCombinations();
    }
  }

  async anotarArchivo(archivo: any): Promise<void> {
    this.fuenteImagen = '';
    this.liberarPdf();
    this.archivoAnotando = archivo;
    this.esPdfActual = this.esArchivoPdf(archivo);
    this.esImagenesMultiplesActual = this.esArchivoImagenesMultiples(archivo);
    this.paginaActual = 1;
    this.totalPaginas = this.esImagenesMultiplesActual ? archivo.imagenes.length : 0;
    this.anotaciones = this.leerAnotaciones(archivo.selected_config);
    this.actualizarAnotacionesPaginaActual();
    this.prepararPosicionesAnotables();
    this.cargarPromocionesParaAnotacion();
    this.anotacionTemporal = null;
    this.posicionPendiente = null;
    this.nivelZoom = 1;
    this.cargandoImagen = true;
    this.errorImagen = false;
    this.liberarImagen();

    try {
      if (this.esImagenesMultiplesActual) {
        await this.cargarPaginaImagenMultiple();
        return;
      }
      const blob = await this.projectService.getFileViewerBlob(archivo.file).toPromise();
      if (!blob) throw new Error('El archivo no contiene datos.');
      const contenidoEsPdf = this.esPdfActual
        || String(blob.type || '').toLowerCase().includes('pdf')
        || await this.contenidoTieneFormatoPdf(blob);
      if (contenidoEsPdf) {
        this.esPdfActual = true;
        this.actualizarAnotacionesPaginaActual();
        await this.cargarPdf(blob);
        return;
      }
      this.urlTemporalImagen = URL.createObjectURL(blob);
      this.fuenteImagen = this.sanitizer.bypassSecurityTrustUrl(this.urlTemporalImagen);
    } catch (error) {
      if (this.esPdfActual) {
        console.error('No fue posible cargar el PDF para anotarlo.', error);
        this.errorAlCargarImagen();
        return;
      }
      this.fuenteImagen = archivo.file;
    }
  }

  volverAlHistorial(): void {
    this.cerrarAnotacion();
  }

  imagenCargada(evento: Event): void {
    const imagen = evento.target as HTMLImageElement;
    this.anchoNatural = imagen.naturalWidth;
    this.altoNatural = imagen.naturalHeight;
    const anchoVisor = this.visorAnotacion?.nativeElement.clientWidth || 760;
    this.anchoBase = Math.min(this.anchoNatural, Math.max(280, anchoVisor - 36), 760);
    this.altoBase = this.anchoBase * this.altoNatural / this.anchoNatural;
    this.cargandoImagen = false;
  }

  errorAlCargarImagen(): void {
    this.cargandoImagen = false;
    this.errorImagen = true;
  }

  async cambiarPaginaPdf(numero: number): Promise<void> {
    if ((!this.esPdfActual && !this.esImagenesMultiplesActual)
      || numero < 1 || numero > this.totalPaginas || numero === this.paginaActual) return;
    this.cancelarSeleccion();
    this.paginaActual = numero;
    this.actualizarAnotacionesPaginaActual();
    if (this.esPdfActual) await this.renderizarPaginaPdf();
    else await this.cargarPaginaImagenMultiple();
  }

  acercarImagen(): void { this.nivelZoom = Math.min(2.5, Number((this.nivelZoom + 0.25).toFixed(2))); }
  alejarImagen(): void { this.nivelZoom = Math.max(0.5, Number((this.nivelZoom - 0.25).toFixed(2))); }

  iniciarSeleccion(evento: PointerEvent): void {
    if (this.cargandoImagen || this.errorImagen || this.anotacionTemporal || !this.posicionesParaAsignar.length) return;
    const superficie = evento.currentTarget as HTMLElement;
    superficie.setPointerCapture(evento.pointerId);
    evento.preventDefault();
    this.seleccionando = true;
    this.puntoInicial = this.coordenadaNormalizada(evento, superficie);
    this.anotacionTemporal = { x: this.puntoInicial.x, y: this.puntoInicial.y, ancho: 0, alto: 0 };
  }

  moverSeleccion(evento: PointerEvent): void {
    if (!this.seleccionando || !this.puntoInicial) return;
    const actual = this.coordenadaNormalizada(evento, evento.currentTarget as HTMLElement);
    this.anotacionTemporal = {
      x: Math.min(this.puntoInicial.x, actual.x),
      y: Math.min(this.puntoInicial.y, actual.y),
      ancho: Math.abs(actual.x - this.puntoInicial.x),
      alto: Math.abs(actual.y - this.puntoInicial.y)
    };
  }

  terminarSeleccion(evento: PointerEvent): void {
    if (!this.seleccionando) return;
    this.moverSeleccion(evento);
    this.seleccionando = false;
    this.puntoInicial = null;
    if (!this.anotacionTemporal || this.anotacionTemporal.ancho < 0.008 || this.anotacionTemporal.alto < 0.008) {
      this.cancelarSeleccion();
    }
  }

  cancelarSeleccion(): void {
    this.seleccionando = false;
    this.puntoInicial = null;
    this.anotacionTemporal = null;
    this.posicionPendiente = null;
  }

  asignarPosicion(numeroPosicion?: number): void {
    if (numeroPosicion !== undefined && numeroPosicion !== null) {
      this.posicionPendiente = numeroPosicion;
    }
    if (!this.anotacionTemporal || !this.posicionPendiente) return;
    const posicion = this.posicionesParaAsignar.find(item => Number(item.numero) === Number(this.posicionPendiente));
    if (!posicion) return;

    this.anotaciones.push({
      posicion: posicion.numero,
      alias: posicion.alias,
      diagramada: posicion.diagramada,
      color: posicion.color,
      pagina: (this.esPdfActual || this.esImagenesMultiplesActual) ? this.paginaActual : 1,
      x: this.redondear(this.anotacionTemporal.x),
      y: this.redondear(this.anotacionTemporal.y),
      ancho: this.redondear(this.anotacionTemporal.ancho),
      alto: this.redondear(this.anotacionTemporal.alto)
    });
    this.anotaciones[this.anotaciones.length - 1].promocionesDetalle = posicion.promocionesDetalle;
    this.anotaciones.sort((a: any, b: any) => Number(a.posicion) - Number(b.posicion));
    this.actualizarAnotacionesPaginaActual();
    this.cancelarSeleccion();
    this.actualizarPosicionesParaAsignar();
  }

  eliminarAnotacion(anotacion: any): void {
    this.anotaciones = this.anotaciones.filter(item => item !== anotacion);
    this.actualizarAnotacionesPaginaActual();
    this.actualizarPosicionesParaAsignar();
  }

  estiloAnotacion(anotacion: any): any {
    return {
      left: `${anotacion.x * 100}%`, top: `${anotacion.y * 100}%`,
      width: `${anotacion.ancho * 100}%`, height: `${anotacion.alto * 100}%`,
      borderColor: anotacion.color
    };
  }

  get posicionSeleccionadaPendiente(): any {
    return this.posicionesParaAsignar.find(posicion => Number(posicion.numero) === Number(this.posicionPendiente)) || null;
  }

  private async cargarPromocionesParaAnotacion(): Promise<void> {
    if (this.cargandoPromocionesAnotacion || this.promocionesCampaniaAnotacion.length) return;
    this.cargandoPromocionesAnotacion = true;
    try {
      const respuesta: any = await this.projectService.getPromotionData(this.data.id_proy_camp).toPromise();
      this.promocionesCampaniaAnotacion = Array.isArray(respuesta?.data) ? respuesta.data : [];
      const columnasRespuesta = Array.isArray(respuesta?.columnas) ? respuesta.columnas : [];
      this.columnasPromocionesAnotacion = columnasRespuesta.length
        ? columnasRespuesta.filter((columna: any) => String(columna).trim())
        : Array.from(new Set(this.promocionesCampaniaAnotacion.flatMap(promocion => Object.keys(promocion))))
          .filter(columna => columna.trim());
      if (!this.columnasPromocionesAnotacion.length) this.columnasPromocionesAnotacion = ['CODIGO PRINCIPAL'];
      this.prepararPosicionesAnotables();
    } catch {
      this.promocionesCampaniaAnotacion = [];
      this.columnasPromocionesAnotacion = ['CODIGO PRINCIPAL'];
    } finally {
      this.cargandoPromocionesAnotacion = false;
    }
  }

  private prepararPosicionesAnotables(): void {
    if (!this.arteSeleccionado) {
      this.posicionesAnotables = [];
      this.posicionesParaAsignar = [];
      return;
    }

    const fila = this.arteSeleccionado.fila;
    const idProyectoFase = this.obtenerIdProyectoFaseSeleccionada();
    const diagramasPorPosicion = new Map<number, any[]>();
    this.diagrams.forEach(diagrama => {
      if (Number(diagrama.id_medio) === Number(fila.idMedio) && Number(diagrama.id_pop) === Number(fila.idPop)) {
        const posicion = Number(diagrama.posicion || 1);
        const diagramas = diagramasPorPosicion.get(posicion) || [];
        diagramas.push(diagrama);
        diagramasPorPosicion.set(posicion, diagramas);
      }
    });

    this.posicionesAnotables = this.posicionesDisponibles(fila.totalPositions)
      .map((numero: number, indice: number) => {
        const diagramasPosicion = diagramasPorPosicion.get(Number(numero)) || [];
        const diagrama = diagramasPosicion.find((item: any) => {
          const idProyectoDiagrama = Number(item.id_proyecto || item.idProyectoContexto || 0);
          return !idProyectoFase || !idProyectoDiagrama || idProyectoDiagrama === idProyectoFase;
        });

        // Una posición libre puede anotarse desde cualquier proyecto. Si ya fue  diagramada, solamente pertenece al proyecto donde existe la diagramacion
        if (diagramasPosicion.length && !diagrama) return null;

        const codigosPromociones = this.array(diagrama?.promociones);
        const promocionesDetalle = codigosPromociones.map(codigo =>
          this.promocionesCampaniaAnotacion.find(promocion =>
            String(promocion['CODIGO PRINCIPAL'] || promocion['CÓDIGO PRINCIPAL']) === String(codigo)
          ) || { 'CODIGO PRINCIPAL': codigo }
        );
        return {
          numero,
          alias: diagrama ? (diagrama.alias || 'Sin alias') : 'Sin diagramar',
          diagramada: !!diagrama,
          promociones: codigosPromociones.length,
          promocionesDetalle,
          color: this.coloresAnotacion[indice % this.coloresAnotacion.length]
        };
      })
      .filter((posicion: any) => posicion !== null);
    this.anotaciones = this.anotaciones.filter(anotacion => {
      const posicionRelacionada = this.posicionesAnotables.find(
        posicion => Number(posicion.numero) === Number(anotacion.posicion)
      );

      // Si la posicion ya fue diagramada en otro proyecto, su anotacion deja
      // de pertenecer al arte del proyecto actual.
      if (!posicionRelacionada && diagramasPorPosicion.has(Number(anotacion.posicion))) {
        return false;
      }

      if (posicionRelacionada) {
        anotacion.alias = posicionRelacionada.alias;
      }
      anotacion.promocionesDetalle = posicionRelacionada?.promocionesDetalle || [];
      anotacion.diagramada = posicionRelacionada?.diagramada === true;
      return true;
    });
    this.actualizarAnotacionesPaginaActual();
    this.actualizarPosicionesParaAsignar();
  }

  private obtenerIdProyectoFaseSeleccionada(): number {
    const fase = this.arteSeleccionado?.fase;
    const idDirecto = Number(fase?.id_proyecto || fase?.idProyecto || 0);
    if (idDirecto) return idDirecto;

    const faseConfigurada = this.array(this.data?.phases).find(
      (item: any) => Number(item.id) === Number(fase?.id)
    );
    return Number(faseConfigurada?.id_proyecto || faseConfigurada?.idProyecto || 0);
  }

  private actualizarPosicionesParaAsignar(): void {
    const posicionesOcupadas = new Set(this.anotaciones.map(item => Number(item.posicion)));
    this.posicionesParaAsignar = this.posicionesAnotables.filter(item => !posicionesOcupadas.has(Number(item.numero)));
  }

  guardarAnotaciones(): void {
    if (!this.archivoAnotando || this.anotacionTemporal || this.guardandoAnotaciones) return;
    const configuracion = {
      version: 1,
      unidad: 'normalizada',
      tipo_archivo: this.esPdfActual ? 'pdf' : (this.esImagenesMultiplesActual ? 'imagenes' : 'imagen'),
      archivo: {
        tipo: this.esPdfActual ? 'pdf' : (this.esImagenesMultiplesActual ? 'imagenes' : 'imagen'),
        paginas: (this.esPdfActual || this.esImagenesMultiplesActual) ? this.totalPaginas : 1
      },
      imagen: { ancho: this.anchoNatural, alto: this.altoNatural },
      anotaciones: this.anotaciones.map(item => ({
        posicion: item.posicion, alias: item.alias, color: item.color,
        pagina: Number(item.pagina || 1), x: item.x, y: item.y, ancho: item.ancho, alto: item.alto
      }))
    };
    const seleccion = this.arteSeleccionado;
    const configuracionGuardada = JSON.stringify(configuracion);
    this.guardandoAnotaciones = true;

    this.projectService.updateDiagramaArchivoShared({
      id: Number(this.archivoAnotando.id),
      selected_config: configuracionGuardada,
      aprobado: Number(this.archivoAnotando.aprobado ?? 1)
    }).subscribe({
      next: () => {
        this.guardandoAnotaciones = false;
        this.cambiosArtesPendientes = true;
        this.huboCambiosGuardados = true;
        this.actualizarArteCompartidoGuardado(this.archivoAnotando.id, configuracionGuardada);
        this.uplateResumenAnotaciones(seleccion.fila);
        Swal.fire('Anotaciones guardadas', 'Las posiciones se relacionaron correctamente con el arte.', 'success');
        this.cerrarAnotacion();
        this.verArtes(seleccion.fila, seleccion.fase);
      },
      error: (error: any) => {
        this.guardandoAnotaciones = false;
        Swal.fire('Error al guardar', error?.error?.data || 'No fue posible guardar las anotaciones.', 'error');
      }
    });
  }

  abrirSubidaArte(): void {
    if (!this.arteSeleccionado) return;

    const seleccion = this.arteSeleccionado;
    const archivoVigente = this.archivosArte.find((archivo: any) => archivo.vigente);
    const idProyectoFase = Number(seleccion.fase?.id_proyecto || seleccion.fase?.idProyecto || 0);
    const proyectoFase = this.data?.proyectosContexto?.[idProyectoFase]
      || this.data?.proyectosContexto?.[String(idProyectoFase)];
    this.matDialog.open(SharedArtsDiagramUploadComponent, {
      panelClass: ['dialogs-md'],
      data: {
        id_proyecto_campana: this.obtenerIdCampana(),
        id_medio: Number(seleccion.fila.idMedio),
        id_pop: Number(seleccion.fila.idPop),
        id_fase: Number(seleccion.fase.id),
        medio: seleccion.fila.medio,
        pop: seleccion.fila.pop,
        fase: seleccion.fase.name,
        folder: proyectoFase?.folder || this.data?.project?.folder || this.data?.campaing?.folder || '',
        archivo_vigente: archivoVigente ? {
          tipo: this.esArchivoPdf(archivoVigente)
            ? 'pdf'
            : (this.esArchivoImagenesMultiples(archivoVigente) ? 'imagenes' : 'imagen'),
          selected_config: archivoVigente.selected_config
        } : null
      }
    }).afterClosed().subscribe(resultado => {
      if (resultado?.reload) {
        this.cambiosArtesPendientes = true;
        this.huboCambiosGuardados = true;
        this.verArtes(seleccion.fila, seleccion.fase);
      }
    });
  }

  nombreUsuarioArchivo(archivo: any): string {
    return archivo.nombre_usuario || archivo.usuario || `Usuario ${archivo.id_usuario}`;
  }

  abrirVisorImagenes(archivo: any): void {
    if (!this.esArchivoImagenesMultiples(archivo)) return;
    this.matDialog.open(ProjectDiagramationArchivosImgComponent, {
      panelClass: ['dialogs-lg'],
      data: {
        id: Number(archivo.id),
        imagenes: archivo.imagenes
      }
    });
  }

  extensionArchivo(archivo: any): string {
    if (this.esArchivoImagenesMultiples(archivo)) return 'IMG';
    const nombre = archivo.name || archivo.file || '';
    const extension = nombre.split('.').pop();
    return extension && extension !== nombre ? extension.toUpperCase() : 'Archivo';
  }

  porcentajeAnotado(archivo: any): number {
    const total = this.arteSeleccionado?.fila.totalPositions || 0;
    return total ? Math.min(100, (archivo.posicionesAnotadas / total) * 100) : 0;
  }

  private contarPosicionesAnotadas(configuracion: any, fila?: any, fase?: any): number {
    const valor = this.parseValue(configuracion);
    const lista = Array.isArray(valor)
      ? valor
      : valor?.anotaciones || valor?.posiciones || valor?.positions || valor?.selected_positions || valor?.selected;

    if (Array.isArray(lista)) {
      if (!fila || !fase) return lista.length;

      const posiciones = lista
        .map((item: any) => Number(item?.posicion ?? item))
        .filter((posicion: number) => posicion > 0);
      const diagramas = this.diagrams.filter((diagrama: any) =>
        Number(diagrama.id_medio) === Number(fila.idMedio)
        && Number(diagrama.id_pop) === Number(fila.idPop)
      );
      const idProyecto = Number(fase.id_proyecto || fase.idProyecto || this.obtenerIdProyectoFase(fase));
      return this.filtrarPosicionesAnotadasPorProyecto(posiciones, diagramas, idProyecto).length;
    }
    if (!valor || typeof valor !== 'object') return 0;

    return Object.values(valor).filter(item => item === true || Number(item) === 1).length;
  }

  private obtenerIdProyectoFase(fase: any): number {
    const faseConfigurada = this.array(this.data?.phases).find((item: any) =>
      Number(item.id) === Number(fase?.id)
    );
    return Number(faseConfigurada?.id_proyecto || faseConfigurada?.idProyecto || 0);
  }

  async verPosiciones(fila: any): Promise<void> {
    this.filaSeleccionada = fila;
    this.cargandoDetalle = true;
    this.detallePosiciones = [];

    try {
      const respuesta: any = await this.projectService.getPromotionData(this.data.id_proy_camp).toPromise();
      const promocionesCampania = respuesta?.data || [];
      const diagramas = this.diagrams.filter(diagrama =>
        Number(diagrama.id_medio) === fila.idMedio && Number(diagrama.id_pop) === fila.idPop);

      this.detallePosiciones = this.posicionesDisponibles(fila.totalPositions).map(numero => {
        const diagrama = diagramas.find(item => Number(item.posicion || 1) === numero) || null;
        const codigos = diagrama ? this.array(diagrama.promociones) : [];
        return {
          numero,
          diagrama,
          arteAnotado: fila.annotatedPositions.includes(numero),
          comentarios: this.obtenerComentariosDiagrama(diagrama),
          promociones: promocionesCampania.filter((promocion: any) => codigos.includes(promocion['CODIGO PRINCIPAL'])),
          vobos: diagrama ? this.obtenerVobos(diagrama) : []
        };
      });

      const primeraPromocion = this.detallePosiciones.flatMap(item => item.promociones)[0];
      this.columnasPromociones = respuesta?.columnas?.length
        ? [...respuesta.columnas]
        : primeraPromocion ? Object.keys(primeraPromocion).filter(columna => columna?.trim()) : [];
      if (this.columnasPromociones.length && !this.columnasPromociones.includes('CODIGO PRINCIPAL')) {
        this.columnasPromociones.unshift('CODIGO PRINCIPAL');
      }
    } catch {
      this.columnasPromociones = [];
      this.detallePosiciones = this.posicionesDisponibles(fila.totalPositions).map(numero => {
        const diagrama = this.diagrams.find(item => Number(item.id_medio) === fila.idMedio && Number(item.id_pop) === fila.idPop && Number(item.posicion || 1) === numero) || null;
        return {
          numero,
          diagrama,
          arteAnotado: fila.annotatedPositions.includes(numero),
          comentarios: this.obtenerComentariosDiagrama(diagrama),
          promociones: [],
          vobos: diagrama ? this.obtenerVobos(diagrama) : []
        };
      });
    } finally {
      this.cargandoDetalle = false;
    }
  }

  volverAlListado(): void {
    this.filaSeleccionada = null;
    this.detallePosiciones = [];
    this.columnasPromociones = [];
  }

  private obtenerVobos(diagrama: any): any[] {
    const configuracion = this.array(diagrama.config_vobos);
    const idProyecto = Number(diagrama.id_proyecto || diagrama.idProyectoContexto || 0);
    const vobosUnicos = new Map<string, any>();

    (this.data?.phases || [])
      .filter((fase: any) => !idProyecto || Number(fase.id_proyecto || 0) === idProyecto)
      .forEach((fase: any) => {
      const faseConfigurada = configuracion.find((item: any) => Number(item.id) === Number(fase.id));
      if (!faseConfigurada) return;

      (fase.vobos || [])
        .filter((vobo: any) => !this.esVoboProveedor(vobo))
        .forEach((vobo: any) => {
        const voboConfigurado = faseConfigurada?.vobos?.find((item: any) => Number(item.id) === Number(vobo.id));
        const estado = Number(voboConfigurado?.status || 0);
        const llave = `${Number(fase.id)}-${Number(vobo.id)}`;
        if (!vobosUnicos.has(llave)) {
          vobosUnicos.set(llave, {
            nombre: (vobo.area || '').substring(0, 3),
            estado,
            aprobado: estado === 1,
            rechazado: estado === 2
          });
        }
      });
    });

    return Array.from(vobosUnicos.values());
  }

  private obtenerComentariosDiagrama(diagrama: any): string {
    return String(
      diagrama?.comentarios
      || diagrama?.comentario
      || diagrama?.COMENTARIOS
      || ''
    ).trim();
  }

  private async loadCombinations(): Promise<void> {
    // Se consulta el catálogo de la campaña y se conservan únicamente los medios que fueron configurados para el proyecto actual
    const id = Number(this.data?.id_proy_camp || this.data?.project?.id_proy_camp);
    await this.loadArtesCompartidosCampana();
    if (!id) { this.setRows(this.rowsFromDiagrams()); return; }

    try {
      const respuestaMedios: any = await this.projectService.getMedios(id).toPromise();
      const mediosSeleccionados = (this.data?.selected_medios || []).map(Number);
      const medios = (respuestaMedios?.data?.medios || []).filter((medio: any) =>
        mediosSeleccionados.includes(Number(medio.id))
        && (medio.imagenes_compartidas === true || Number(medio.imagenes_compartidas) === 1));

      const catalog = await Promise.all(medios.map(async (medio: any) => {
        try {
          const respuestaPops: any = await this.projectService.getPOPs(medio.id).toPromise();
          return { medium: medio, pops: respuestaPops?.data?.elementos_pop || [] };
        } catch {
          return { medium: medio, pops: [] };
        }
      }));

      const rows = catalog.flatMap(item => item.pops.map((pop: any) => this.createRow(item.medium, pop)));
      this.setRows(rows);
    } catch {
      this.loadError = true;
      this.setRows(this.rowsFromDiagrams());
    }
  }

  private async loadArtesCompartidosCampana(): Promise<void> {
    const idCampana = this.obtenerIdCampana();
    if (!idCampana) {
      this.archivosCompartidosCampana = [];
      return;
    }

    try {
      const respuesta: any = await this.projectService.getDiagramaArchivoSharedCampana({
        id_proyecto_campana: idCampana
      }).toPromise();
      const datos = respuesta?.data?.archivos || respuesta?.data || respuesta || [];
      this.archivosCompartidosCampana = (Array.isArray(datos) ? datos : [])
        .filter((archivo: any) => Number(archivo.deleted || 0) !== 1);
    } catch {
      this.archivosCompartidosCampana = [];
    }
  }

  private obtenerPosicionesAnotadas(idMedio: number, idPop: number, idFase?: number): number[] {
    const archivos = this.archivosCompartidosCampana
      .filter(archivo => Number(archivo.id_medio) === idMedio && Number(archivo.id_pop) === idPop)
      .filter(archivo => !idFase || Number(archivo.id_phase || archivo.id_fase) === idFase)
      .sort((a: any, b: any) => {
        const fechaA = new Date(a.created_at || 0).getTime() || 0;
        const fechaB = new Date(b.created_at || 0).getTime() || 0;
        return fechaB - fechaA || Number(b.id) - Number(a.id);
      });

    const archivosVigentes = new Map<number, any>();
    archivos.forEach(archivo => {
      const fase = Number(archivo.id_phase || archivo.id_fase || 0);
      if (!archivosVigentes.has(fase)) archivosVigentes.set(fase, archivo);
    });

    const posiciones = Array.from(archivosVigentes.values()).flatMap(archivo =>
      this.leerAnotaciones(archivo.selected_config).map(anotacion => Number(anotacion.posicion))
    );
    return this.unique(posiciones);
  }

  private actualizarArteCompartidoGuardado(idArchivo: number, configuracion: string): void {
    const indice = this.archivosCompartidosCampana.findIndex(archivo => Number(archivo.id) === Number(idArchivo));
    if (indice >= 0) {
      this.archivosCompartidosCampana[indice] = {
        ...this.archivosCompartidosCampana[indice],
        selected_config: configuracion
      };
      return;
    }

    this.archivosCompartidosCampana.push({
      ...this.archivoAnotando,
      selected_config: configuracion,
      id_medio: this.arteSeleccionado?.fila.idMedio,
      id_pop: this.arteSeleccionado?.fila.idPop,
      id_phase: this.arteSeleccionado?.fase.id
    });
  }

  private uplateResumenAnotaciones(fila: any): void {
    fila.annotatedPositions = this.obtenerPosicionesAnotadas(fila.idMedio, fila.idPop)
      .filter(posicion => posicion <= fila.totalPositions);
    const diagramas = this.diagrams.filter(diagrama => Number(diagrama.id_medio) === Number(fila.idMedio)
      && Number(diagrama.id_pop) === Number(fila.idPop));
    fila.phases = this.buildPhases(diagramas, fila.totalPositions, fila.idMedio, fila.idPop);
    fila.phaseGroups = this.agruparFasesPorProyecto(fila.phases);
    this.dataSource.data = [...this.dataSource.data];
  }

  private rowsFromDiagrams(): any[] {
    const unique = new Map<string, any>();
    const mediosSeleccionados = (this.data?.selected_medios || []).map(Number);
    this.diagrams
      .filter(d => mediosSeleccionados.includes(Number(d.id_medio)))
      .filter(d => d.imagenes_compartidas === true || Number(d.imagenes_compartidas) === 1)
      .forEach(d => { const key = `${d.id_medio}-${d.id_pop}`; if (!unique.has(key)) unique.set(key, { id: d.id_pop, nombre: d.pop, posiciones: 0, medium: { id: d.id_medio, nombre: d.medio } }); });
    return Array.from(unique.values()).map(x => this.createRow(x.medium, x));
  }

  private createRow(medium: any, pop: any): any {
    const diagrams = this.diagrams.filter(d => Number(d.id_medio) === Number(medium.id) && Number(d.id_pop) === Number(pop.id));
    const positions = this.unique(diagrams.map(d => Number(d.posicion || 1)));
    const declared = Number(pop.posiciones || pop.positions || 0);
    const total = declared > 0 ? declared : Math.max(...positions, 1);
    const annotatedPositions = this.obtenerPosicionesAnotadas(Number(medium.id), Number(pop.id))
      .filter(posicion => posicion <= total);
    const phases = this.buildPhases(diagrams, total, Number(medium.id), Number(pop.id));
    return { idMedio: Number(medium.id), idPop: Number(pop.id), medio: medium.nombre || medium.name || diagrams[0]?.medio || '-', pop: pop.nombre || pop.name || diagrams[0]?.pop || '-', totalPositions: total,
      diagrammedPositions: positions, annotatedPositions, phases,
      phaseGroups: this.agruparFasesPorProyecto(phases) };
  }

  private buildPhases(diagrams: any[], maximoPosiciones: number, idMedio: number, idPop: number): any[] {
    const proyectosDiagramados = new Set(
      diagrams.map((diagrama: any) => Number(diagrama.id_proyecto || diagrama.idProyectoContexto)).filter(Boolean)
    );
    return (this.data?.phases || [])
      .filter((phase: any) => proyectosDiagramados.has(Number(phase.id_proyecto)))
      .map((phase: any) => {
      const diagramasFase = diagrams.filter((diagrama: any) =>
        !phase.id_proyecto || Number(diagrama.id_proyecto || diagrama.idProyectoContexto) === Number(phase.id_proyecto)
      );
      const posicionesDiagramadas = this.unique(diagramasFase.map(diagrama => Number(diagrama.posicion || 1)));
      const totalPosiciones = maximoPosiciones;
      const posicionesAnotadasFase = this.filtrarPosicionesAnotadasPorProyecto(
        this.obtenerPosicionesAnotadas(idMedio, idPop, Number(phase.id))
          .filter(posicion => posicion <= totalPosiciones),
        diagrams,
        Number(phase.id_proyecto || 0)
      );
      const art = posicionesAnotadasFase.length;
      const arteCompartidoVigente = this.obtenerArteCompartidoVigente(idMedio, idPop, Number(phase.id));
      const arteRechazado = arteCompartidoVigente && Number(arteCompartidoVigente.aprobado) === 0;
      const estadoArte = arteRechazado
        ? 'error'
        : arteCompartidoVigente
          ? (art >= totalPosiciones && totalPosiciones > 0 ? 'complete' : 'partial')
          : 'empty';
      const indicadores: any[] = [{
        id: `art-${phase.id}`,
        label: 'Art',
        name: `Arte - ${phase.name || phase.nombre}`,
        type: 'art',
        completed: art,
        total: totalPosiciones,
        status: estadoArte
      }];
      (phase.vobos || [])
        .filter((vobo: any) => !this.esVoboProveedor(vobo))
        .forEach((vobo: any) => {
        const idFaseVobo = Number(vobo.phase_id || phase.id);
        const posicionesAprobadas = this.unique(diagramasFase
          .filter(diagrama => Number(this.findVobo(diagrama, idFaseVobo, vobo.id)?.status) === 1)
          .map(diagrama => Number(diagrama.posicion || 1)));
        const posicionesRechazadas = this.unique(diagramasFase
          .filter(diagrama => Number(this.findVobo(diagrama, idFaseVobo, vobo.id)?.status) === 2)
          .map(diagrama => Number(diagrama.posicion || 1)));
        const aprobadas = posicionesAprobadas.length;
        indicadores.push({
          id: `vobo-${phase.id}-${vobo.id}`,
          label: vobo.is_provider_vobo ? 'Pro' : (vobo.area || '').substring(0, 3),
          name: vobo.area,
          type: 'vobo',
          vobo,
          completed: aprobadas,
          total: totalPosiciones,
          status: this.estadoAprobaciones(aprobadas, posicionesRechazadas.length, totalPosiciones)
        });
      });
      return {
        id: Number(phase.id),
        id_proyecto: Number(phase.id_proyecto || 0),
        name: phase.name || phase.nombre,
        totalPosiciones,
        posicionesDiagramadas,
        posicionesAnotadas: posicionesAnotadasFase,
        indicadores
      };
    });
  }

  private filtrarPosicionesAnotadasPorProyecto(
    posicionesAnotadas: number[],
    diagramasMedioPop: any[],
    idProyecto: number
  ): number[] {
    return posicionesAnotadas.filter((posicion: number) => {
      const diagrama = diagramasMedioPop.find((item: any) =>
        Number(item.posicion || 1) === Number(posicion)
      );

      // Mientras la posicion siga libre, puede estar anotada en el arte de
      // cualquier proyecto. Una vez diagramada, solo pertenece a su proyecto.
      if (!diagrama) return true;

      const idProyectoDiagrama = Number(diagrama.id_proyecto || diagrama.idProyectoContexto || 0);
      return !idProyecto || !idProyectoDiagrama || idProyectoDiagrama === idProyecto;
    });
  }

  private agruparFasesPorProyecto(fases: any[]): any[] {
    const grupos = new Map<number, any>();
    fases.forEach((fase: any) => {
      const idProyecto = Number(fase.id_proyecto);
      if (!grupos.has(idProyecto)) {
        const proyecto = this.data?.proyectosContexto?.[idProyecto]
          || this.data?.proyectosContexto?.[String(idProyecto)];
        grupos.set(idProyecto, {
          idProyecto,
          nombreProyecto: proyecto?.nombre || proyecto?.name || `Proyecto ${idProyecto}`,
          totalPosiciones: 0,
          posicionesDiagramadas: [],
          posicionesAnotadas: [],
          fases: []
        });
      }
      const grupo = grupos.get(idProyecto);
      grupo.totalPosiciones = Math.max(grupo.totalPosiciones, Number(fase.totalPosiciones || 0));
      grupo.posicionesDiagramadas = this.unique([
        ...grupo.posicionesDiagramadas,
        ...(fase.posicionesDiagramadas || [])
      ]);
      grupo.posicionesAnotadas = this.unique([
        ...grupo.posicionesAnotadas,
        ...(fase.posicionesAnotadas || [])
      ]);
      grupo.fases.push(fase);
    });
    return Array.from(grupos.values());
  }

  private async abrirVobosCompartidos(fila: any, fase: any, vobo: any): Promise<void> {
    if (this.esVoboProveedor(vobo)) return;
    const arteCompartido = this.obtenerArteCompartidoVigente(fila.idMedio, fila.idPop, fase.id);
    if (!arteCompartido) {
      Swal.fire('Sin arte compartido', 'No existe un arte compartido para esta fase.', 'warning');
      return;
    }

    const diagramas = this.diagrams.filter((diagrama: any) =>
      Number(diagrama.id_medio) === Number(fila.idMedio)
      && Number(diagrama.id_pop) === Number(fila.idPop)
      && (!fase.id_proyecto
        || Number(diagrama.id_proyecto || diagrama.idProyectoContexto) === Number(fase.id_proyecto))
    );
    if (!diagramas.length) {
      Swal.fire('Sin diagramaciones', 'No existen posiciones diagramadas para este medio y POP.', 'warning');
      return;
    }

    try {
      const idProyecto = Number(fase.id_proyecto || diagramas[0]?.id_proyecto || diagramas[0]?.idProyectoContexto);
      const proyectoConfigurado = this.data?.proyectosContexto?.[idProyecto]
        || this.data?.proyectosContexto?.[String(idProyecto)];
      if (!proyectoConfigurado) {
        Swal.fire('Sin configuración', 'No se encontró la configuración del proyecto para esta fase.', 'warning');
        return;
      }
      this.mainService.ShowLoading();
      const respuestaUsuarios: any = await this.projectService.getUsersByPermiso('upl_artes').toPromise();
      this.mainService.HideLoading();
      const fases = proyectoConfigurado.fases || [];
      const orden: any[] = [];
      fases.forEach((faseProyecto: any) => {
        orden.push({ tipo: 'art', id_fase: faseProyecto.id });
        (faseProyecto.vobos || [])
          .filter((voboProyecto: any) => !this.esVoboProveedor(voboProyecto))
          .forEach((voboProyecto: any) => {
          orden.push({
            tipo: voboProyecto.is_provider_vobo == 1 ? 'prov' : 'vobo',
            id_fase: faseProyecto.id,
            id_vobo: voboProyecto.id
          });
        });
      });

      this.matDialog.open(ProjectDiagramationVobosComponent, {
        panelClass: ['dialogs-xxl'],
        disableClose: true,
        data: {
          modoArteCompartidoMultiple: true,
          phase: fase,
          diagram: diagramas[0],
          diagramasCompartidos: diagramas,
          totalPosicionesCompartidas: fila.totalPositions,
          archivoCompartido: arteCompartido,
          project: {
            ...proyectoConfigurado,
            id_proy_camp: this.obtenerIdCampana(),
            folder: proyectoConfigurado.folder || this.data?.campaing?.folder
          },
          form_vb: (proyectoConfigurado.form_vb || []).filter((formulario: any) =>
            (vobo.vobos || []).includes(formulario.id)
          ),
          vobo,
          campaign: this.data.campaing,
          arr_order: orden,
          projectConf: [{
            ...proyectoConfigurado,
            id_proy_camp: this.obtenerIdCampana(),
            folder: proyectoConfigurado.folder || this.data?.campaing?.folder
          }],
          isConsecutivo: false,
          art_users: respuestaUsuarios?.data || []
        }
      }).afterClosed().subscribe(resultado => {
        if (resultado?.reload) {
          this.huboCambiosGuardados = true;
          this.recargarDespuesDeVobo();
        }
      });
    } catch {
      this.mainService.HideLoading();
      Swal.fire('Error', 'No fue posible cargar la configuración de VoBos.', 'error');
    }
  }

  private async recargarDespuesDeVobo(): Promise<void> {
    this.loading = true;
    this.mainService.ShowLoading();

    try {

      
      let respuesta: any = await this.projectService.getProjectsSlim(this.obtenerIdCampana()).toPromise();
      const configuracion = respuesta?.data || respuesta || {};

      if (Array.isArray(configuracion.diagram_all)) {
        const diagramacionesAnteriores = [
          ...(this.data?.projectDiagramations || []),
          ...(this.data?.projectAllDiagramations || [])
        ];
        const diagramacionesActualizadas = configuracion.diagram_all.map((diagrama: any) => {
          const anterior = diagramacionesAnteriores.find((item: any) => Number(item.id) === Number(diagrama.id));
          return {
            ...anterior,
            ...diagrama,
            comentarios: diagrama.comentarios
              ?? diagrama.comentario
              ?? anterior?.comentarios
              ?? anterior?.comentario
              ?? '',
            idProyectoContexto: Number(diagrama.id_proyecto || anterior?.id_proyecto)
          };
        });
        this.data.projectAllDiagramations = diagramacionesActualizadas;
        this.data.projectDiagramations = diagramacionesActualizadas;
      }
      if (Array.isArray(configuracion.groupedPhases)) {
        this.data.phases = configuracion.groupedPhases;
      }
      if (configuracion.proyectos && typeof configuracion.proyectos === 'object') {
        this.data.proyectosContexto = configuracion.proyectos;
        const mediosSeleccionados = this.obtenerMediosSeleccionadosProyectos(configuracion.proyectos);
        if (mediosSeleccionados.length) this.data.selected_medios = mediosSeleccionados;
      }
    } catch (error) {
      console.error('No fue posible actualizar las diagramaciones después del VoBo.', error);
    } finally {
      this.mainService.HideLoading();
      await this.loadCombinations();
    }
  }

  private obtenerMediosSeleccionadosProyectos(proyectos: any): number[] {
    const medios = new Set<number>();
    Object.values(proyectos || {}).forEach((proyecto: any) => {
      this.array(proyecto?.selected_medios).forEach((idMedio: any) => medios.add(Number(idMedio)));
    });
    return Array.from(medios);
  }

  private obtenerIdCampana(): number {
    return Number(
      this.data?.id_proy_camp
      || this.data?.project?.id_proy_camp
      || this.data?.id_proyecto_campana
    );
  }

  private obtenerIdProyecto(): number {
    return Number(
      this.data?.id_proyecto
      || this.data?.project?.id
      || this.data?.id_proyecto_campana
    );
  }

  private obtenerArteCompartidoVigente(idMedio: number, idPop: number, idFase: number): any {
    return this.archivosCompartidosCampana
      .filter((archivo: any) => Number(archivo.id_medio) === idMedio
        && Number(archivo.id_pop) === idPop
        && Number(archivo.id_phase || archivo.id_fase) === idFase)
      .sort((a: any, b: any) =>
        new Date(b.created_at || 0).getTime() - new Date(a.created_at || 0).getTime()
      )[0] || null;
  }

  private async abrirHistorialDirecto(): Promise<void> {
    await this.loadArtesCompartidosCampana();
    const idMedio = Number(this.data.idMedioDirecto);
    const idPop = Number(this.data.idPopDirecto);
    const diagramas = this.diagrams.filter(diagrama =>
      Number(diagrama.id_medio) === idMedio && Number(diagrama.id_pop) === idPop
    );
    const referencia = diagramas[0] || this.data.arteCompartidoActivo || {};
    let pop = { id: idPop, nombre: referencia.pop || 'POP', posiciones: referencia.posiciones || 0 };
    try {
      const respuestaPops: any = await this.projectService.getPOPs(idMedio).toPromise();
      const popCatalogo = (respuestaPops?.data?.elementos_pop || []).find((item: any) =>
        Number(item.id) === idPop
      );
      if (popCatalogo) pop = popCatalogo;
    } catch {
      // Si el catálogo no está disponible, se conserva la información recibida en la diagramación.
    }
    const fila = this.createRow(
      { id: idMedio, nombre: referencia.medio || 'Medio' },
      pop
    );
    this.setRows([fila]);
    await this.verArtes(fila, this.data.faseDirecta);
  }

  private findVobo(diagram: any, phaseId: number, voboId: number): any {
    const fase = this.array(diagram.config_vobos).find((item: any) => Number(item.id) === Number(phaseId));
    return this.array(fase?.vobos).find((item: any) => Number(item.id) === Number(voboId));
  }
  private get diagrams(): any[] {
    const diagramacionesActuales = this.data?.projectDiagramations || [];
    return (this.data?.projectAllDiagramations || []).map((diagrama: any) => {
      const diagramaActual = diagramacionesActuales.find((actual: any) => Number(actual.id) === Number(diagrama.id));
      return {
        ...diagrama,
        comentarios: diagramaActual?.comentarios
          ?? diagramaActual?.comentario
          ?? diagrama.comentarios
          ?? diagrama.comentario
          ?? '',
        config_vobos: this.array(diagramaActual?.config_vobos ?? diagrama.config_vobos)
      };
    });
  }

  private parseValue(value: any): any { 
    if (typeof value !== 'string') 
      return value; try { return JSON.parse(value); } catch { return null; } 
  }

  private leerAnotaciones(configuracion: any): any[] {
    const valor = this.parseValue(configuracion);
    const lista = Array.isArray(valor) ? valor : valor?.anotaciones;
    if (!Array.isArray(lista)) return [];
    return lista.filter((item: any) => Number(item.posicion) > 0
      && [item.x, item.y, item.ancho, item.alto].every((numero: any) => Number.isFinite(Number(numero))))
      .map((item: any, indice: number) => ({
        posicion: Number(item.posicion),
        alias: item.alias || 'Sin alias', color: item.color || this.coloresAnotacion[indice % this.coloresAnotacion.length],
        pagina: Number(item.pagina || 1), x: Number(item.x), y: Number(item.y), ancho: Number(item.ancho), alto: Number(item.alto)
      }))
      .sort((a: any, b: any) => Number(a.posicion) - Number(b.posicion));
  }

  private esVoboProveedor(vobo: any): boolean {
    const valor = vobo?.is_provider_vobo;
    return valor === true || Number(valor) === 1 || String(valor).toLowerCase() === 'true';
  }

  private esArchivoPdf(archivo: any): boolean {
    const nombre = String(archivo?.name || archivo?.file || '').toLowerCase().split('?')[0];
    return String(archivo?.type || '').toLowerCase().includes('pdf') || nombre.endsWith('.pdf');
  }

  private esArchivoImagenesMultiples(archivo: any): boolean {
    return !archivo?.file && Array.isArray(archivo?.imagenes) && archivo.imagenes.length > 0;
  }

  private async cargarPaginaImagenMultiple(): Promise<void> {
    const imagen = this.archivoAnotando?.imagenes?.[this.paginaActual - 1];
    if (!imagen?.file) {
      this.errorAlCargarImagen();
      return;
    }

    this.cargandoImagen = true;
    this.errorImagen = false;
    this.fuenteImagen = '';
    this.liberarImagen();
    try {
      const blob = await this.projectService.getFileViewerBlob(imagen.file).toPromise();
      if (!blob) throw new Error('La imagen no contiene datos.');
      this.urlTemporalImagen = URL.createObjectURL(blob);
      this.fuenteImagen = this.sanitizer.bypassSecurityTrustUrl(this.urlTemporalImagen);
    } catch {
      this.fuenteImagen = imagen.file;
    }
  }

  private async contenidoTieneFormatoPdf(blob: Blob): Promise<boolean> {
    const cabecera = new Uint8Array(await blob.slice(0, 1024).arrayBuffer());
    let texto = '';
    cabecera.forEach(valor => texto += String.fromCharCode(valor));
    return texto.includes('%PDF-');
  }

  private prepararMotorPdf(): void {
    if (!(globalThis as any).pdfjsWorker?.WorkerMessageHandler) {
      require('pdfjs-dist/build/pdf.worker.js');
    }
  }

  private async cargarPdf(blob: Blob): Promise<void> {
    this.prepararMotorPdf();
    const datos = new Uint8Array(await blob.arrayBuffer());
    const carga = pdfjsLib.getDocument({ data: datos, isEvalSupported: false });
    this.documentoPdf = await carga.promise;
    this.totalPaginas = Number(this.documentoPdf.numPages || 0);
    if (!this.totalPaginas) throw new Error('El PDF no contiene páginas.');
    await new Promise(resolve => setTimeout(resolve));
    await this.renderizarPaginaPdf();
  }

  private async renderizarPaginaPdf(): Promise<void> {
    const canvas = this.lienzoPdf?.nativeElement;
    if (!canvas || !this.documentoPdf) return;
    this.cargandoImagen = true;
    this.errorImagen = false;
    try {
      if (this.renderizadoPdf) this.renderizadoPdf.cancel();
      const pagina = await this.documentoPdf.getPage(this.paginaActual);
      const vistaBase = pagina.getViewport({ scale: 1 });
      this.anchoNatural = vistaBase.width;
      this.altoNatural = vistaBase.height;
      const anchoVisor = this.visorAnotacion?.nativeElement.clientWidth || 760;
      this.anchoBase = Math.min(this.anchoNatural, Math.max(280, anchoVisor - 36), 760);
      this.altoBase = this.anchoBase * this.altoNatural / this.anchoNatural;

      const escalaRenderizado = Math.max(1.5, window.devicePixelRatio || 1);
      const vistaRenderizado = pagina.getViewport({ scale: escalaRenderizado });
      canvas.width = Math.floor(vistaRenderizado.width);
      canvas.height = Math.floor(vistaRenderizado.height);
      const contexto = canvas.getContext('2d');
      if (!contexto) throw new Error('No fue posible preparar el lienzo del PDF.');
      this.renderizadoPdf = pagina.render({ canvasContext: contexto, viewport: vistaRenderizado });
      await this.renderizadoPdf.promise;
      this.renderizadoPdf = null;
    } catch (error: any) {
      if (error?.name !== 'RenderingCancelledException') {
        console.error('No fue posible renderizar la página del PDF.', error);
        this.errorImagen = true;
      }
    } finally {
      this.cargandoImagen = false;
    }
  }

  private actualizarAnotacionesPaginaActual(): void {
    this.anotacionesPaginaActual = this.anotaciones.filter(anotacion =>
      (!this.esPdfActual && !this.esImagenesMultiplesActual)
      || Number(anotacion.pagina || 1) === this.paginaActual
    );
  }

  private coordenadaNormalizada(evento: PointerEvent, superficie: HTMLElement): any {
    const limites = superficie.getBoundingClientRect();
    return {
      x: Math.max(0, Math.min(1, (evento.clientX - limites.left) / limites.width)),
      y: Math.max(0, Math.min(1, (evento.clientY - limites.top) / limites.height))
    };
  }

  private redondear(numero: number): number { return Number(numero.toFixed(6)); }

  private cerrarAnotacion(): void {
    this.archivoAnotando = null;
    this.fuenteImagen = '';
    this.esImagenesMultiplesActual = false;
    this.anotaciones = [];
    this.anotacionesPaginaActual = [];
    this.posicionesAnotables = [];
    this.posicionesParaAsignar = [];
    this.cancelarSeleccion();
    this.liberarImagen();
    this.liberarPdf();
  }

  private liberarImagen(): void {
    if (this.urlTemporalImagen) URL.revokeObjectURL(this.urlTemporalImagen);
    this.urlTemporalImagen = '';
  }

  private liberarPdf(): void {
    if (typeof this.renderizadoPdf?.cancel === 'function') {
      this.renderizadoPdf.cancel();
    }
    this.renderizadoPdf = null;
    if (typeof this.documentoPdf?.destroy === 'function') {
      this.documentoPdf.destroy();
    } else if (typeof this.documentoPdf?.cleanup === 'function') {
      this.documentoPdf.cleanup();
    }
    this.documentoPdf = null;
    this.totalPaginas = 0;
  }

  private array(value: any): any[] { 
    if (Array.isArray(value))
       return value; try { return value ? JSON.parse(value) : []; } catch { return []; } 
  }

  private unique(values: number[]): number[] {
     return Array.from(new Set(values.filter(v => Number.isFinite(v) && v > 0))).sort((a, b) => a - b);
   }

  private status(done: number, total: number): 'complete'|'partial'|'empty' { return !done || !total ? 'empty' : done >= total ? 'complete' : 'partial'; }
  private estadoAprobaciones(aprobadas: number, rechazadas: number, total: number): 'complete'|'partial'|'error'|'empty' {
    if (!total) return 'empty';
    if (aprobadas >= total) return 'complete';
    if (rechazadas >= total) return 'error';
    return aprobadas + rechazadas > 0 ? 'partial' : 'empty';
  }

  private setRows(rows: any[]): void { 
    this.dataSource.data = rows; this.actualizarFiltro();
    this.loading = false;
  }
}
